import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Config from './config'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(require('vue-moment'));
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$config = Config

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
